import { Patient } from '@bioliberty/lifemind';
import { DialogDescription } from '@radix-ui/react-dialog';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDeletePatientMutation } from '../../../api';
import { Button } from '../../../components/Button';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from '../../../components/Dialog';
import { Route } from '../../../constants';
import { useToaster } from '../../../hooks/useToaster';

type DeletePatientModalProps = {
  patient: Patient;
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

export const DeletePatientModal = ({ patient, open, onOpenChange }: DeletePatientModalProps) => {
  const navigate = useNavigate();
  const toast = useToaster();

  const [deletePatient, { isLoading: isDeleting }] = useDeletePatientMutation();

  const onDelete = useCallback(async () => {
    try {
      await deletePatient(patient.id);
      navigate(Route.Patients);
      toast.success('Patient deleted successfully.');
    } catch {
      toast.error('Failed to delete patient. Please try again.');
    }
  }, [patient.id, deletePatient, navigate, toast]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Delete {patient.alias}</DialogTitle>
          <DialogDescription>Are you sure you want to delete this patient?</DialogDescription>
        </DialogHeader>

        <DialogFooter>
          <Button variant="danger" onClick={onDelete} disabled={isDeleting} isLoading={isDeleting}>
            Delete
          </Button>
          <DialogClose asChild>
            <Button variant="transparent">Cancel</Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
